import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { ValueProps } from "@/components/site/ValueProps";
import { Footer } from "@/components/site/Footer";
import { WhyChooseChicago } from "@/components/site/WhyChooseChicago";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));
const Reviews = lazy(() => import("@/components/site/Reviews").then(m => ({ default: m.Reviews })));
const RestoreComparison = lazy(() => import("@/components/site/RestoreComparison").then(m => ({ default: m.RestoreComparison })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/why-restore")({
  head: () => ({
    links: [{ rel: "canonical", href: "https://restorehair.com/why-restore/" }],
    meta: [
      { title: "Why RESTORE® — Get Your Hair Back | RESTORE® Hair" },
      {
        name: "description",
        content:
          "Why men choose RESTORE®: expert hair transplant doctors, natural undetectable results, and a proven track record trusted by pro athletes and celebrities.",
      },
      { property: "og:title", content: "Why RESTORE® — Get Your Hair Back | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "Why men choose RESTORE®: expert doctors, natural undetectable results, and a track record trusted by pro athletes.",
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <WhyChooseChicago showProsHeadline headingTag="h1" />
        <ValueProps hideEyebrowMobile />
        <Suspense fallback={null}>
          <Results hideEyebrowMobile resultsHref="https://restorehair.com/results/" resultsButtonLabel="See More Results" />
          <Reviews hideEyebrowMobile />
          <RestoreComparison />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
